import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// local dependencies
import { callItemNotesWidget as CallItemNotesWidgetView } from 'ui/views/widgets/callItemNotesWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { CallItemNotesWidgetService } from 'services/callItemNotesWidget';

//import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
//import queryString from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallItemNotesWidget } from 'ui/containers/CallItemNotesWidgetWidget';
 *
 * // render
 * <CallItemNotesWidget propName='propValue'/>
 */
export class CallItemNotesWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        //this.handleActionClick = this.handleActionClick.bind( this );

        // create service instance
        this.callItemNotesWidgetService = new CallItemNotesWidgetService();
        
        // start data fetch
        this.fetchComponentData();
    }

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallItemNotesWidget.fetchComponentData()' );

        // cancel ongoing request
        this.callItemNotesWidgetService.cancel();

        // fetch component data
        const { status, data } = await this.callItemNotesWidgetService.fetchComponentData(  {
            url: this.props.widget.url,
            data: this.props.requestPayload
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.callItemNotesWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallItemNotesWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
            />
        );
    }
}

// set display name
CallItemNotesWidget.displayName = 'CallItemNotesWidget';

// set default props
CallItemNotesWidget.defaultProps = {
    widget: {}, // widget configuration
};

// prop types
CallItemNotesWidget.propTypes = {};

export const ActionListWidget = withRouter( CallItemNotesWidget );
